/* eslint-disable import-x/no-namespace */
import type React from 'react';

import { createFastFilterDateLabel } from '@vlabs/monokit/shared/lib/fast-filter-date-label';
import { FastFilterGroup } from '@vlabs/monokit/shared/ui/fast-filter-group';

import * as fastFilters from './fast-filters';
import { useUserListFilters } from './useUserListPageFilters';

function UserListFastFilters(): React.JSX.Element {
  const { filters, updateFilters } = useUserListFilters();

  return (
    <FastFilterGroup>
      {!!filters.role_id && (
        <fastFilters.UserRoleFilterWithBottomPopover
          onClear={() => updateFilters({ role_id: undefined })}
          value={filters.role_id}
        />
      )}
      {!!filters.department_id && (
        <fastFilters.DepartmentFilterWithBottomPopover
          onClear={() => updateFilters({ department_id: undefined })}
          value={filters.department_id}
        />
      )}
      {!!(filters.last_login_at__gte ?? filters.last_login_at__lt) && (
        <fastFilters.LastLoginDateFilterWithBottomPopover
          onClear={() => updateFilters({ last_login_at__gte: undefined, last_login_at__lt: undefined })}
          value={createFastFilterDateLabel({
            createTimeGte: filters.last_login_at__gte,
            createTimeLt: filters.last_login_at__lt,
          })}
        />
      )}
      {!!filters.full_name && (
        <fastFilters.UserNameFilterWithBottomPopover
          onClear={() => updateFilters({ full_name: undefined })}
          value={filters.full_name}
        />
      )}
      {!!filters.email && (
        <fastFilters.UserEmailFilterWithBottomPopover
          onClear={() => updateFilters({ email: undefined })}
          value={filters.email}
        />
      )}
      {!!filters.user_ids?.length && (
        <fastFilters.UserIdFilterWithBottomPopover
          onClear={() => updateFilters({ user_ids: undefined })}
          value={filters.user_ids[0] as string}
        />
      )}
      {!!(filters.create_time__gte ?? filters.create_time__lt) && (
        <fastFilters.DateCreatedFilterWithBottomPopover
          onClear={() => updateFilters({ create_time__gte: undefined, create_time__lt: undefined })}
          value={createFastFilterDateLabel({
            createTimeGte: filters.create_time__gte,
            createTimeLt: filters.create_time__lt,
          })}
        />
      )}
    </FastFilterGroup>
  );
}

export { UserListFastFilters };
